/* istanbul ignore file */

export const SUBSCRIPTION_URL = '/subscription';
export const SUBSCRIPTION_HISTORY_URL = `${SUBSCRIPTION_URL}/history`;
export const SUBSCRIPTION_PLANS_URL = `${SUBSCRIPTION_URL}/plans`;
export const SUBSCRIPTION_SUCCESS_URL = `${SUBSCRIPTION_URL}/success`;
export const SUBSCRIPTION_CANCEL_URL = `${SUBSCRIPTION_URL}/cancel`;
export const CHECKOUT_URL = '/checkout/subscription';
export const PROJECTS_URL = '/projects';
export const PUBLIC_PROJECTS_URL = '/public/:userId';
export const PROJECT_URL = `${PROJECTS_URL}/:projectId`;
export const WORKBENCH_URL = '/workbench/:projectId';
export const PROJECT_TRANSCRIPT_URL = `${PROJECTS_URL}/:projectId/transcript/:segId`;
export const PROJECT_VIDEO_URL = `${PROJECTS_URL}/:projectId/:videoId`;
export const PROJECT_VIDEO_TRANSCRIPT_URL = `${PROJECTS_URL}/:projectId/:videoId/transcript/:segmentId`;
export const BRAND_KIT_URL = '/brand-kit';
export const BRAND_KIT_EVENT_URL = '/brand-kit/:eventId';
export const STREAM_KEYS_URL = '/stream-keys';
export const RUNSHEETS_URL = '/runsheets';
export const RUNSHEET_NEW_URL = `${RUNSHEETS_URL}/new`;
export const RUNSHEET_EDIT_URL = `${RUNSHEETS_URL}/:runsheetId`;
export const STREAM_KEYS_SUCCESS_URL = `${STREAM_KEYS_URL}/success`;
export const STREAM_KEYS_CANCEL_URL = `${STREAM_KEYS_URL}/cancel`;
export const INTEGRATIONS_URL = '/integrations';
export const MAIN_URL = '/';
export const BLOG_URL = 'https://editonthespot.com/blog';
export const TUTORIALS_URL = 'https://editonthespot.com/blog';

export const CAPTIONS_URL = '/captions';

export const USERS_URL = '/users';
export const CREATE_USER_URL = 'users/create';
export const UPDATE_USER_URL = 'users/:userId';
export const ORG_USERS_URL = '/org-users';
export const EVENTS_URL = '/events';
export const INVITATION_URL = '/invitation/:invitationId';
